<template>
  <b-modal id="createDevicePeripheralDeviceModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmdeviceperipheraldevice.createDevicePeripheralDeviceHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMDevicePeripheralDeviceCreate :deviceIRI="deviceIRI"></EXCMDevicePeripheralDeviceCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMDevicePeripheralDeviceCreate from '../Create.vue'
export default {
  name: 'CreateDevicePeripheralDeviceModal',
  components: {
    EXCMDevicePeripheralDeviceCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmdeviceperipheraldevice.create.show
    },
    computedDeviceIRI () {
      return this.$store.state.modals.excmdeviceperipheraldevice.create.deviceIRI
    },
    close () {
      return this.$store.state.modals.excmdeviceperipheraldevice.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      deviceIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedDeviceIRI) {
        this.deviceIRI = this.$store.state.modals.excmdeviceperipheraldevice.create.deviceIRI
        this.$store.state.modals.excmdeviceperipheraldevice.create.show = 0
        this.$store.state.modals.excmdeviceperipheraldevice.create.deviceIRI = null
        this.$bvModal.show('createDevicePeripheralDeviceModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmdeviceperipheraldevice.create.close = 0
        this.$bvModal.hide('createDevicePeripheralDeviceModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
